import Vue from 'vue';
import { defineStore } from 'pinia';

import { sortObjects } from '@watchtowerbenefits/es-utils-public';
import { getBrokers } from '@/services/broker.js';

export const useBrokersStore = defineStore('brokers', {
  state: () => ({
    brokers: [],
    currentBrokerId: null,
    brokerUsers: [],
  }),
  getters: {
    currentBroker: (state) => (state.currentBrokerId ? state.brokers.find(({ id }) => +id === +state.currentBrokerId) : null),
  },
  actions: {
    /**
     * Grab all the brokers and save them to the store
     */
    async loadBrokers() {
      try {
        const { brokers } = await getBrokers();

        Vue.set(this, 'brokers', sortObjects(brokers, 'name'));
      } catch {
        // We should eventually catch and handle any errors here
      }
    },
    /**
     * Add broker to state array of brokers
     *
     * @param {string} broker
     */
    addBroker(broker) {
      const newBrokers = [...this.brokers, broker];

      Vue.set(this, 'brokers', sortObjects(newBrokers, 'name'));
    },
    /**
     * Updates broker with broker param
     *
     * @param {object} broker
     */
    updateBroker(broker) {
      const brokerIndex = this.brokers.findIndex(({ id }) => id === broker.id);

      Vue.set(this.brokers, brokerIndex, broker);
      this.brokers = sortObjects(this.brokers, 'name');
    },
  },
});
